var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTransactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11833 0.124722C7.61833 -0.145278 9.05834 0.0347224 10.3258 0.552222C10.4608 0.607221 10.5958 0.668887 10.7308 0.730552C10.7983 0.761387 10.8658 0.792221 10.9333 0.822222C11.3833 1.05472 11.4733 1.66222 11.1133 2.02222C10.8808 2.25472 10.5283 2.30722 10.2358 2.15722C9.18583 1.61722 7.95583 1.36972 6.65833 1.54972C4.01083 1.91722 1.87333 4.07722 1.55083 6.73222C1.07833 10.5797 4.25084 13.8197 8.07584 13.4672C10.2733 13.2647 12.1633 11.7722 13.0333 9.73972C13.5133 8.60722 13.5883 7.54222 13.4233 6.54472C13.3783 6.30472 13.4533 6.04972 13.6258 5.87722C14.0608 5.44972 14.8033 5.68222 14.9008 6.28222C15.0733 7.27972 15.0433 8.34472 14.7433 9.44722C13.9633 12.3347 11.4733 14.5472 8.50333 14.9297C3.47084 15.5822 -0.744165 11.2472 0.110835 6.18472C0.628335 3.13222 3.06583 0.672222 6.11833 0.124722ZM6.96583 10.4147L14.4658 2.91472C14.7583 2.62222 14.7583 2.14972 14.4583 1.85722C14.1658 1.56472 13.6933 1.56472 13.4008 1.85722L6.43333 8.82472L4.84334 7.23472C4.55084 6.94222 4.07833 6.94222 3.78583 7.23472C3.49334 7.52722 3.49334 7.99972 3.78583 8.29222L5.90833 10.4147C6.20083 10.7072 6.67334 10.7072 6.96583 10.4147Z",
    fill: "#245F18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTransactionIcon);
export default __webpack_public_path__ + "static/media/success-transaction-icon.ad0847da5d32ff01dba18ad0a058dbdc.svg";
export { ForwardRef as ReactComponent };